import {Grid, Paper, Typography} from "@material-ui/core";
import {useEffect, useState} from "react";
import {client} from "../../../dataProvider";

export const ValidatedBar = () => {
    const [validated, setValidated] = useState<{
        validated: number;
        unvalidated: number;
    }>({
        validated: 0,
        unvalidated: 0,
    });

    useEffect(() => {
        client("validation_for_user", {
            method: "GET",
        }).then(response => {
            setValidated({
                validated: response.validated,
                unvalidated: response.unvalidated,
            })
        })
    }, [])

    return (
        <Grid container>
        <Grid item xs={8}>
        </Grid>
        <Grid item xs={2}>
          <Paper elevation={2} style={{
            textAlign: "center",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
            <Typography variant="body1" style={{ fontWeight: 500, color: "green" }}>
              VALIDATI
            </Typography>
            <Typography variant="h4" style={{color:"green"}}>
              {validated["validated"]}
            </Typography>
          </Paper>
        </Grid>

        <Grid item xs={2}>
          <Paper elevation={2} style={{
            textAlign: "center",
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
            <Typography variant="body1" color="primary" style={{ fontWeight: 500 }}>
              INVALIDATI
            </Typography>
            <Typography variant="h4" color="primary">
              {validated["unvalidated"]}
            </Typography>
          </Paper>
        </Grid>
      </Grid>
    )
};

